import { render } from "./ZircVenColor.vue?vue&type=template&id=2f379acc"
import script from "./ZircVenColor.vue?vue&type=script&lang=js"
export * from "./ZircVenColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__